import { useMemo } from 'react';

import { IconApplicants } from '@components/icons/applicants';
import { FilterConfigField } from '@components/table';

import { useStore } from 'models/Provider';

export const useMessageApplicantNameFilter = (): FilterConfigField => {
  const { t } = useStore();

  return useMemo(
    () => ({
      id: 'names',
      label: t('messages.filters.name.title'),
      icon: <IconApplicants />,
      type: 'text',
      allowedComparers: ['is', 'contains', 'starts'],
      toExternalQuery: (filter) => {
        const value = String(filter.value);

        switch (filter.comparer) {
          case 'is':
            return { application__name__iexact: value };
          case 'contains':
            return { application__name__icontains: value };
          case 'starts':
            return { application__name__startswith: value };
          default:
            return {};
        }
      },
    }),
    [t],
  );
};
